// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"96b46522","496":"f18de977","515":"e749359d","773":"10d0733f"}[chunkId] + ".chunk.js";
};